<template>
  <!-- 绑定搜知账号 -->
  <div>
    <h1 style="font-weight: bold;line-height:40px">
      <span class="back" @click="back"><left-Outlined/></span>
      绑定手机号
    </h1>
    <div style="color: rgb(102, 102, 102); font-size: 12px; font-weight: bold">
      微信首次登录，需要绑定手机号
    </div>
    <div style="margin: 40px auto">
      <span
        style="
          float: left;
          margin-bottom: 15px;
          font-weight: bold;
          font-size: 16px;
          color: #333;
        "
        >输入登录账号</span
      >
      <a-input v-model:value.trim()="phone" placeholder="请输入您的手机号" style="height:44px;color:#333;background: #f3f3f4;"/>
      <!-- <span
        style="
          float: left;
          margin-top: 45px;
          font-weight: bold;
          font-size: 16px;
          color: #333;
        "
        >输入验证码</span
      > -->
       <div class="input-wrap drag-verify" v-show="!hasSend">
            <span
              style="
                float: left;
                font-weight: bold;
                font-size: 16px;
                color: #333;
              "
              >验证码</span
            ><br />
            <div class="bar" style="margin-top: 15px">
              <div class="bar-con">请按住滑块拖到最右边</div>
              <div class="draged" ref="draged"></div>
              <div class="drag-btn" ref="dragBtn">&gt;&gt;</div>
              <div class="cover"></div>
            </div>
            <div class="clear"></div>
          </div>

          <a-input-group
            compact
            style="
              margin-top: 20px;
              color: #333;
              font-size: 16px;
              font-weight: bold;
            "
            class="inputWrap"
            v-show="hasSend"
          >
            <div style="float: left">输入验证码</div>
            <br />
            <a-input
              v-model:value="verifyCode"
              style="
                width: calc(100% - 102px);
                text-align: left;
                margin-top: 15px;
                background: #f3f3f4;
                height: 44px;
              "
            />
            <a-button
              type="button"
              class="btn"
              @click="getCode"
              style="width: 102px; margin-top: 15px; height: 44px;"
              :disabled="btnText !== '重新发送'"
              >{{ btnText }}</a-button
            >
          </a-input-group>
      <a-button
        type="button"
        @click="login"
        style="margin-top: 55px; width: 225px;height: 44px;background: #000;color: white;border:none"
        >立即登录</a-button
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, toRefs, reactive ,onMounted,ref} from "vue";
import { useRouter, useRoute } from "vue-router";
import Http from "../../until/http";
import { LeftOutlined } from "@ant-design/icons-vue";
import {
  getCookie,
  messageTips,
  setCookie,
  setLocalItem,
  isPhone,
} from "../../until/tools";
var timer;
export default defineComponent({
  components: {
    LeftOutlined,
  },
  setup() {
    let draged = ref(null);
    let dragBtn = ref(null);
    const state = reactive({
      phone: "",
      verifyCode: "",
      sid: getCookie("z_sid"),
      hasSend: false,
      btnText: "重新发送",
    });
    const router = useRouter();
    const route = useRoute();
    const back = () => {
      router.push("/login");
    };
    const getCode = () => {
      if (state.phone === "") {
        messageTips("请输入手机号", 2);
        return;
      }
      if (!isPhone(state.phone)) {
        messageTips("请输入正确的手机号", 2);
        return;
      }
      Object.assign(state, {
        btnText: 59 + "s",
      });
      Http.getSign({ account: state.phone }).then((res) => {
        Http.getCode({ account: state.phone, sign: res.sign }).then((res) => {
          if (res.verifyCode) {
            Object.assign(state, {
              verifyCode: res.verifyCode,
            });
          }
        });
      });
      let seconds = 59;
      timer = setInterval(() => {
        Object.assign(state, {
          btnText: seconds + "s",
        });
        if (seconds < 0) {
          clearInterval(timer);
          Object.assign(state, {
            btnText: "重新发送",
          });
          return false;
        }
        seconds -= 1;
      }, 1000);
    };
    const login = (e) => {
      e.preventDefault();
      if (state.phone === "") {
        messageTips("请输入手机号", 2);
        return false;
      }
      if (!isPhone(state.phone)) {
        messageTips("请输入正确的手机号", 2);
        return false;
      }
      if (state.verifyCode === "") {
        messageTips("请输入验证码", 2);
        return false;
      }

      Http.mobileIsExist({
        mobile: state.phone,
      }).then((res) => {
        if (res.message == "该手机号不存在") {
          if (route.query.sign == 66) {
            window.location.href =
              "http://test.sozdata.com/#/login/bind?account=" +
              state.phone +
              "&&verifyCode=" +
              state.verifyCode +
              "?sign=66" +
              "&&openSid=" +
              route.query.openSid;
          } else if (route.query.sign == 88) {
            window.location.href =
              "http://test.sozdata.com/#/login/bind?account=" +
              state.phone +
              "&&verifyCode=" +
              state.verifyCode +
              "?sign=88" +
              "&&openSid=" +
              route.query.openSid;
          } else {
            window.location.href =
              "http://test.sozdata.com/#/login/bind?account=" +
              state.phone +
              "&&verifyCode=" +
              state.verifyCode +
              "&&openSid=" +
              route.query.openSid;
          }
        } else {
          Http.login({
            account: state.phone,
            verifyCode: state.verifyCode,
            openSid: route.query.openSid.split("?")[0],
          }).then((res) => {
            if (res.success) {
              setCookie("z_sid", res.sid, 1);
              setCookie("userId", res.userInfo.userId, { time: 1 });
              setLocalItem("userInfo", res.userInfo);
              setLocalItem("isUserLogin", {
                isUserLogin: res.isUserLogin,
              });
            } else {
              messageTips(res.message, 1);
              return false;
            }
            if (route.query.sign == 66) {
              window.location.href =
                "http://test.sozdata.com/site.html#/index";
            } else if (route.query.sign == 88) {
              window.location.href =
                "http://test.sozdata.com/tqexam.html#/user/signUp";
            } else {
              window.location.href = "#/index";
            }
          });
        }
      });
    };
    onMounted(() => {
      var dragBtnDom = dragBtn.value;
      var leftBorder = 880 - 362 + (window.innerWidth - 880) / 2;
      dragBtnDom.onmousedown = () => {
        dragBtnDom.style.transition = "";
        draged.value.style.transition = "";
        if (state.phone === "") {
          messageTips("请输入手机号", 2);
          return;
        }
        if (!isPhone(state.phone)) {
          messageTips("请输入正确的手机号", 2);
          return;
        }
        var newLeft;
        document.onmousemove = (e) => {
          newLeft = e.pageX - leftBorder;
          if (newLeft < 0) {
            newLeft = 0;
          }
          if (newLeft > 375) {
            newLeft = 375;
          }
          dragBtnDom.style.left = newLeft + "px";
          draged.value.style.width = newLeft + "px";
        };
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
          if (newLeft) {
            if (newLeft < 375) {
              dragBtnDom.style.left = 0;
              dragBtnDom.style.transition = "all 400ms ease 0s";
              draged.value.style.width = 0;
              draged.value.transition = "all 400ms ease 0s";
            } else {
              //clearInterval(setTimer);
              Object.assign(state, {
                hasSend: true,
                btnText: "59秒刷新",
              });
              getCode();
            }
          }
        };
        return false;
      };

      window.onresize = () => {
        leftBorder = 880 - 362 + (window.innerWidth - 880) / 2;
      };
    })
    return {
      back,
      login,
      getCode,
      ...toRefs(state),
      draged,
      dragBtn,
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/ .ant-btn-button{
  color: #727272;
  font-size: 16px;
}
/deep/ .ant-btn-button:hover{
  border-color:#387bf6;
  color: #387bf6;
}
/deep/ input:hover{
 border-color:#387bf6;
  color: #387bf6;
}
.input-wrap {
  position: relative;
  margin-top: 20px;
  .label-name {
    text-align: left;
  }
  .bar {
    height: 44px;
    background: #f3f3f4;
    border-radius: 4px;
    position: relative;
    width: 440px;
  }
  .bar .bar-con {
    line-height: 44px;
    text-align: center;
    font-size: 15px;
    color: #aaa;
  }
  .bar .drag-btn {
    width: 64px;
    height: 44px;
    font-size: 21px;
    position: absolute;
    top: 0;
    left: 0;
    color: #bbb;
    background: #fff;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    border: 1px solid #d8d8d8;
  }
  .bar .drag-btn .ico-pass {
    width: 14px;
    height: 14px;
    background-position: -30px -57px;
    position: relative;
    top: 2px;
  }
  .bar .draged {
    height: 44px;
    width: 0;
    background: #387bf6;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 15px;
  }
  .bar .cover {
    width: 100%;
    height: 44px;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    display: none;
  }
}
.back {
  float: left;
  font-size: 26px;
  cursor: pointer;
}
.name {
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: -250px;
}
.sketch {
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: -210px;
}
/deep/ .ant-btn-primary:disabled{
  font-size: 14px;
  color: #b8b8b8;
  background: #f3f3f4;
   border: 1px solid #d9d9d9;
}
.inputWrap{
.ant-btn[disabled]:hover{
  color: #b8b8b8;
  border: 1px solid #d9d9d9;
}
/deep/.ant-btn[disabled]:focus{
  color: #b8b8b8 !important;
}
}
</style>